// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline-publish-date{font-family:var(--font-family-system);font-size:11px;font-weight:600;color:var(--color-grey-1);line-height:1;margin-top:10px}", ""]);
// Exports
module.exports = exports;
